import { useQuery } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";
import { TSyncQueueItem } from "../types";

type SyncQueueParams = { company_id?: number; status?: string; entity_type?: string; page?: number; limit?: number };

export const useSyncQueueList = (params: SyncQueueParams = { limit: 50 }) => {
  return useQuery({
    queryKey: [API_ENDPOINTS.SYNC_QUEUE, params],
    queryFn: () => client.get(API_ENDPOINTS.SYNC_QUEUE, { params }),
    select: (res: any) => ({
      data: res.data.data as TSyncQueueItem[],
      extra: res.data.extra as { total: number; page: number; limit: number },
    }),
    refetchOnWindowFocus: false,
  });
};
